import React from "react";
import { useWindowWidth } from "../../../lib/hooks/useWindowWidth";

import { ThemeLink } from "../../../components/shared/ThemeLink/ThemeLink";

import "./Logo.scss";

interface Props {
  noLink?: boolean;
  loading?: boolean;
}

export const Logo = (props: Props) => {
  const windowWidth = useWindowWidth();

  const isMobile = windowWidth <= 1024;

  return (
    <div className="Logo">
      {props.noLink ? (
        <img
          style={
            isMobile ? { width: 140, height: 30 } : { width: 222, height: 45 }
          }
          src={require("../../../assets/images/profiti-shop.png")}
          alt="logo"
        />
      ) : (
        <ThemeLink to="/">
          <img
            style={
              isMobile ? { width: 140, height: 30 } : { width: 222, height: 45 }
            }
            src={require("../../../assets/images/profiti-shop.png")}
            alt="logo"
          />
        </ThemeLink>
      )}
    </div>
  );
};
